import { createSlice } from '@reduxjs/toolkit';
import { CustomerPortalModel } from '../../Helpers/Interfaces/CustomerPortalModel';

const initialState: CustomerPortalModel = {
    productShowcase1: {
        "title": "", /*Recommended for you*/
        "products": [],
        "isPublished": true
    },
    productShowcase2: {
        "title": "", /*Exclusive Black Friday Week Deals*/
        "bg": "",
        "bgType": "color",
        "isPublished": true,
        "products": [],
        "textColor": "",
        "btnColor": ""
    },
    productShowcase3: {
        "title": "", /*Top Black Friday Week Picks*/
        "products": [],
        "isPublished": false
    },
    productShowcase4: {
        "title": "", /*Where to Find the Deals*/
        "products": [],
        "isPublished": false
    },
    productShowcase5: {
        "title": "", /*Gaming Picks for Black Friday Week*/
        "products": [],
        "isPublished": true
    },
    productShowcase6: {
        "title": "", /*Apparel*/
        "products": [],
        "isPublished": false
    }
}

const CustomerPortalLayoutSlice = createSlice({
    name: 'CustomerPortalLayoutSlice',
    initialState: initialState,
    reducers: {
        setProductShowcase1: (state, action) => {
            state.productShowcase1 = action.payload;
        },
        setProductShowcase2: (state, action) => {
            state.productShowcase2 = action.payload;
        },
        setProductShowcase3: (state, action) => {
            state.productShowcase3 = action.payload;
        },
        setProductShowcase4: (state, action) => {
            state.productShowcase4 = action.payload;
        },
        setProductShowcase5: (state, action) => {
            state.productShowcase5 = action.payload;
        },
        setProductShowcase6: (state, action) => {
            state.productShowcase6 = action.payload;
        },
    },
});

export const { setProductShowcase1, setProductShowcase2, setProductShowcase3, setProductShowcase4, setProductShowcase5, setProductShowcase6 } = CustomerPortalLayoutSlice.actions;
export default CustomerPortalLayoutSlice;